import React from 'react';

import FilestackUpload from '../../FilestackUpload/FilestackUpload';
import type { FieldRenderProps } from '../../form';

interface UploadFieldAdapterProps extends FieldRenderProps {
  options: any;
  buttonText?: string;
  labelText: string;
  disabled?: boolean;
  onChange?: (...args: any[]) => void;
}

const UploadFieldAdapter: React.FC<UploadFieldAdapterProps> = ({
  buttonText,
  input,
  options,
  labelText,
  disabled = false,
  onChange,
  meta: { error, touched },
}) => {
  const getError = (err: any) => {
    if (typeof err === 'string') return err;
    return err.message ?? '';
  };
  return (
    <FilestackUpload
      options={options}
      buttonText={buttonText}
      labelText={labelText}
      initialFiles={Array.isArray(input.value) ? input.value : []}
      onChange={({ value }) => {
        input.onChange(value);
        onChange?.(value);
      }}
      disabled={disabled}
      errorMessage={getError(touched && error ? error : '')}
    />
  );
};

export default UploadFieldAdapter;
